var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"before-close":_vm.close,"append-to-body":"","title":"消息详情"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"dialog-content"},[_vm._v(" "+_vm._s(_vm.detail.id)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }